var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3835",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FFB2B2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path300",
    d: "M43.4295 19.2983V22.707H20.5723V19.2983H29.1432H34.858H43.4295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    d: "M41.3127 22.7129V45.8042C41.3127 46.739 40.5699 47.4531 39.5983 47.4531H24.4562C23.4846 47.4531 22.7412 46.739 22.7412 45.8042V22.7129H41.3127Z",
    fill: "#FFCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M39.5991 48H24.457C23.1996 48 22.1709 47.0103 22.1709 45.801V22.7098C22.1709 22.3799 22.3997 22.1597 22.742 22.1597C23.0855 22.1597 23.3136 22.3799 23.3136 22.7098V45.801C23.3136 46.4059 23.8277 46.9005 24.457 46.9005H39.5991C40.2278 46.9005 40.7424 46.4059 40.7424 45.801V22.7098C40.7424 22.3799 40.9706 22.1597 41.3135 22.1597C41.657 22.1597 41.8852 22.3799 41.8852 22.7098V45.801C41.8852 47.0103 40.8565 48 39.5991 48Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "M43.4289 23.2617H20.5717C20.2282 23.2617 20 23.0416 20 22.7117V19.248C20 18.9181 20.2282 18.6986 20.5717 18.6986H29.1426C29.486 18.6986 29.7142 18.9181 29.7142 19.248C29.7142 19.5779 29.486 19.7981 29.1426 19.7981H21.1427V22.1617H42.8573V19.7981H34.8574C34.514 19.7981 34.2858 19.5779 34.2858 19.248C34.2858 18.9181 34.514 18.6986 34.8574 18.6986H43.4289C43.7712 18.6986 44 18.9181 44 19.248V22.7117C44 23.0416 43.7712 23.2617 43.4289 23.2617Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M29.714 18.7482H34.2856V17.0987H29.714V18.7482ZM34.8572 19.8477H29.1424C28.8001 19.8477 28.5713 19.6276 28.5713 19.2977V16.5487C28.5713 16.2188 28.8001 15.9992 29.1424 15.9992H34.8572C35.1996 15.9992 35.4284 16.2188 35.4284 16.5487V19.2977C35.4284 19.5727 35.1996 19.8477 34.8572 19.8477Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "M36.2855 42.5039C35.9432 42.5039 35.7139 42.2843 35.7139 41.9544V28.2096C35.7139 27.8797 35.9432 27.6596 36.2855 27.6596C36.6284 27.6596 36.8572 27.8797 36.8572 28.2096V41.9544C36.8572 42.2843 36.6284 42.5039 36.2855 42.5039Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M31.9998 42.5039C31.6575 42.5039 31.4287 42.2843 31.4287 41.9544V28.2096C31.4287 27.8797 31.6575 27.6596 31.9998 27.6596C32.3432 27.6596 32.5715 27.8797 32.5715 28.2096V41.9544C32.5715 42.2843 32.3432 42.5039 31.9998 42.5039Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M27.7137 42.5039C27.3713 42.5039 27.1426 42.2843 27.1426 41.9544V28.2096C27.1426 27.8797 27.3713 27.6596 27.7137 27.6596C28.0571 27.6596 28.2853 27.8797 28.2853 28.2096V41.9544C28.2853 42.2843 28.0571 42.5039 27.7137 42.5039Z",
    fill: "#EA4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a5960e038a28406907e500d919a8adc2.svg";
export { ForwardRef as ReactComponent };